import { createAction } from '@reduxjs/toolkit';

import { NAME } from './constants';
import type { OnboardingFormData } from './types';

// Registration flow actions
export const startRegistration = createAction(`${NAME}/startRegistration`);

export const submitRegistration = createAction<OnboardingFormData>(
  `${NAME}/submitRegistration`
);

export const registrationSuccess = createAction(`${NAME}/registrationSuccess`);

export const registrationFailure = createAction<string>(`${NAME}/registrationFailure`);

export const navigateToStep = createAction<string>(`${NAME}/navigateToStep`);